import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M24.0002 29.4837L23.5288 26.5446C23.3497 25.4275 22.7754 24.3827 21.7856 23.8347C18.5022 22.0169 14.498 22.0169 11.2147 23.8347C10.225 24.3827 9.6507 25.4275 9.47156 26.5445L9.00018 29.4837",
				stroke: "var(--stroke-0, #C2C2C2)",
				strokeWidth: 3,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M20.2498 14.2502C20.2498 16.3212 18.5709 18.0002 16.4998 18.0002C14.4288 18.0002 12.7498 16.3212 12.7498 14.2502C12.7498 12.1792 14.4288 10.5002 16.4998 10.5002C18.5709 10.5002 20.2498 12.1792 20.2498 14.2502Z",
				stroke: "var(--stroke-0, #C2C2C2)",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M31.5 16.5C31.5 24.7842 24.7842 31.5 16.5 31.5C8.21572 31.5 1.5 24.7842 1.5 16.5C1.5 8.21572 8.21572 1.5 16.5 1.5C24.7842 1.5 31.5 8.21572 31.5 16.5Z",
				stroke: "var(--stroke-0, #C2C2C2)",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M16.5 31.5C24.7842 31.5 31.5 24.7842 31.5 16.5C31.5 8.21575 24.7842 1.50002 16.5 1.50002",
				stroke: "var(--stroke-0, #C2C2C2)",
				strokeWidth: 3,
				strokeLinecap: "round"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgPerson);
export { ForwardRef as ReactComponent };
